import { CloneResourceService } from "./clone-resource.service";

const mod = angular.module("cloning", []);

/**
 * TODO CLEAR UP PREVIOUS CLONING FUNCTIONALITY
 * & PACK IT UP INTO A SINGLE MODULE HERE.
 * FOR NOW NEW CLONING IS ENABLED VIA refactor-session-cloning
 */
mod.service("CloneResourceService", CloneResourceService);

export default mod.name;
